import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { activateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "msisdn",
  "extra_data.imei",
  "last_updated",
];

const VerizonActivateBatch = () => (
  <BatchDetail
    title="Activate"
    apiGet={__getActivate}
    client={CLIENTS.verizon}
    columnsFactory={(ctx) =>
      activateColumns({ ...ctx, showAreacode: false, showZipcode: true, showTrialCount: true, showImei: true })
    }
    copyKeys={COPY_KEYS}
    exportAction="activate"
    showTerminate
    getRowPath={(row) => `/verizon/activate/${row.id}`}
  />
);

export default VerizonActivateBatch;
